var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SportModel } from "../../../model";
import { liveStreamingMode } from "../../..";
export class LiveStreamingBaseRetriever {
    constructor(gateway, dict, refreshInterval, liveStreamingMode) {
        this.streamingId = "streaming";
        this.gateway = gateway;
        this.dict = dict;
        this.refreshInterval = refreshInterval;
        this.liveStreamingMode = liveStreamingMode;
        this.isActive = false;
        this.liveStreamingRefreshTimer = -1;
    }
    activate() {
        this.isActive = true;
    }
    refresh(state, requestFactory) {
        return __awaiter(this, void 0, void 0, function* () {
            window.clearTimeout(this.liveStreamingRefreshTimer);
            return this.refreshInternal(state, requestFactory);
        });
    }
    refreshInternal(state, requestFactory) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = requestFactory();
            const response = yield this.getCount(request);
            if (this.isActive) {
                response && this.updateLiveStreaming(state, response);
                if (this.refreshInterval > 0) {
                    this.liveStreamingRefreshTimer = window.setTimeout(() => this.refreshInternal(state, requestFactory), this.refreshInterval);
                }
            }
        });
    }
    getCount(request) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.gateway.getCountByTag(request);
            }
            catch (_a) {
                return;
            }
        });
    }
    updateLiveStreaming(state, data) {
        const eventsCount = data.events ? data.events : 0;
        if (eventsCount > 0) {
            const liveStreamingItem = state.getItemById(this.streamingId);
            if (liveStreamingItem) {
                state.update(this.streamingId, { numberOfEvents: eventsCount });
            }
            else {
                state.add(this.getStreamingItem(eventsCount));
            }
        }
        else {
            state.remove(this.streamingId);
        }
    }
    getStreamingItem(numberOfEvents) {
        return new SportModel({
            id: this.streamingId,
            name: this.dict.streaming,
            numberOfEvents,
            order: this.getStreamingItemOrder()
        }, "liveStream");
    }
    getStreamingItemOrder() {
        switch (this.liveStreamingMode) {
            case liveStreamingMode.firstSelected:
            case liveStreamingMode.first: return -1;
            case liveStreamingMode.last: return 1000;
        }
    }
    deactivate() {
        this.isActive = false;
        window.clearTimeout(this.liveStreamingRefreshTimer);
    }
}
//# sourceMappingURL=LiveStreamingBaseRetriever.js.map